import React from 'react';

const UI = {
  spacing: { xs: 6, sm: 8, md: 12, lg: 16, xl: 24 },
  radius: { sm: 6, md: 8, lg: 12 },
  colors: {
    primary: "#0F172A",
    secondary: "#334155",
    muted: "#64748B",
    border: "#E2E8F0",
    bg: "#F8FAFC",
    success: "#059669",
    warning: "#D97706",
    danger: "#DC2626",
    info: "#3B82F6"
  }
};

const Badge = ({ variant = 'default', children }) => {
  const getStyles = () => {
    switch (variant) {
      case 'success':
        return { background: '#D1FAE5', color: '#059669' };
      case 'warning':
        return { background: '#FEF3C7', color: '#D97706' };
      case 'danger':
        return { background: '#FEE2E2', color: '#DC2626' };
      case 'info':
        return { background: '#E0F2FE', color: '#0369A1' };
      default:
        return { background: UI.colors.bg, color: UI.colors.secondary };
    }
  };
  
  const styles = getStyles();
  
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: 20,
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      fontSize: 11,
      fontWeight: 600,
      background: styles.background,
      color: styles.color
    }}>
      {children}
    </span>
  );
};

export default Badge;